module.exports = __webpack_public_path__ + "img/Free-Expert Advice.a99d280c.png";